import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const ContractsPage = lazy(() => import('@/pages/contracts/ui/index'))

export const Route = createFileRoute('/_protected/contracts/')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <ContractsPage />
    </Suspense>
  ),
})
